if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.isVerticalScroll = this.classList.contains('vertical-scroll') && window.innerWidth >= 1025 && !this.closest('.quick-add-modal');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });

        this.prevButtonnew = this.querySelector('button[name="previousnew"]');
	      this.nextButtonnew = this.querySelector('button[name="nextnew"]');

        this.initSliderButtonState();
        this.prevButtonnew.addEventListener('click', this.onButtonClickNew.bind(this));
	      this.nextButtonnew.addEventListener('click', this.onButtonClickNew.bind(this));

        if (this.dataset.desktopLayout.includes('thumbnail') && this.isVerticalScroll) this.removeListSemantic();
      }

      initSliderButtonState() {
        const currentButton = document.querySelector('.thumbnail-list button[aria-current="true"]');
        if (!currentButton) return;

        const currentLi = currentButton.closest('li');
        if (!currentLi) return;

        const nextBtn = document.querySelector('button[name="nextnew"]');
        const prevBtn = document.querySelector('button[name="previousnew"]');

        let hasPrev = false;
        let hasNext = false;

        // 檢查是否有前一個 li
        let prevLi = currentLi.previousElementSibling;
        while (prevLi) {
          if (prevLi.tagName === 'LI') {
            hasPrev = true;
            break;
          }
          prevLi = prevLi.previousElementSibling;
        }

        // 檢查是否有下一個 li
        let nextLi = currentLi.nextElementSibling;
        while (nextLi) {
          if (nextLi.tagName === 'LI') {
            hasNext = true;
            break;
          }
          nextLi = nextLi.nextElementSibling;
        }

        // 根據結果設定 disabled 狀態
        if (prevBtn) {
          prevBtn.classList.toggle('disabled', !hasPrev);
        }
        if (nextBtn) {
          nextBtn.classList.toggle('disabled', !hasNext);
        }
      }

     onButtonClickNew(event) {
        const clickedButton = event?.target?.closest('button');
        if (!clickedButton || clickedButton.classList.contains('disabled')) return;

        const buttonName = clickedButton.name;
        if (!buttonName || (buttonName !== 'nextnew' && buttonName !== 'previousnew')) return;

        const currentButton = document.querySelector('.thumbnail-list button[aria-current="true"]');
        if (!currentButton) return;

        const currentLi = currentButton.closest('li');
        if (!currentLi) return;

        let targetLi = null;

        if (buttonName === 'nextnew') {
          targetLi = currentLi.nextElementSibling;
          while (targetLi && targetLi.tagName !== 'LI') {
            targetLi = targetLi.nextElementSibling;
          }
        } else if (buttonName === 'previousnew') {
          targetLi = currentLi.previousElementSibling;
          while (targetLi && targetLi.tagName !== 'LI') {
            targetLi = targetLi.previousElementSibling;
          }
        }

        const nextBtn = document.querySelector('button[name="nextnew"]');
        const prevBtn = document.querySelector('button[name="previousnew"]');

        if (targetLi) {
          const target = targetLi.dataset.target;
          this.setActiveMedia(target);
          console.log(`切換到 ${buttonName === 'nextnew' ? '下一張' : '上一張'}，data-target:`, target);

          // 重新判斷新位置是否在邊界
          let hasPrev = false;
          let hasNext = false;

          let checkPrev = targetLi.previousElementSibling;
          while (checkPrev) {
            if (checkPrev.tagName === 'LI') {
              hasPrev = true;
              break;
            }
            checkPrev = checkPrev.previousElementSibling;
          }

          let checkNext = targetLi.nextElementSibling;
          while (checkNext) {
            if (checkNext.tagName === 'LI') {
              hasNext = true;
              break;
            }
            checkNext = checkNext.nextElementSibling;
          }

          // 更新按鈕狀態
          prevBtn?.classList.toggle('disabled', !hasPrev);
          nextBtn?.classList.toggle('disabled', !hasNext);
        } else {
          console.log(`已經是${buttonName === 'nextnew' ? '最後一張' : '第一張'}，沒有更多的 li 元素`);

          // 加上 disabled 狀態
          if (buttonName === 'nextnew') {
            nextBtn?.classList.add('disabled');
          } else {
            prevBtn?.classList.add('disabled');
          }
        }
      }


      onSlideChanged(event) {
        console.log(event);
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) || this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.isVerticalScroll) {
            activeMedia.parentElement.scrollTo({ top: activeMedia.offsetTop });
          } else {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
          
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.isVerticalScroll) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}